/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:1 1 100%;display:flex;flex-flow:column}mat-sidenav[_ngcontent-%COMP%]{display:flex;height:100%;width:200px}mat-sidenav[_ngcontent-%COMP%]   ca-sidenav[_ngcontent-%COMP%]{width:100%}mat-sidenav[_ngcontent-%COMP%]     h2{padding-left:1rem}mat-sidenav[_ngcontent-%COMP%]     button{padding-left:2rem;width:100%}mat-sidenav-container[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };
